import { useState } from 'react';
import './App.css';
import Dashboard from './Dashboard';
import ETF from './ETF';
import ReEntryAnalyzer from './ReEntryAnalyzer';
import Settings from './Settings';
import { useNotifications } from './useNotifications';

/* ── Navigation config ── */
const TABS = [
  { id: 'dashboard', label: 'Dashboard', icon: '📊', Screen: Dashboard        },
  { id: 'etf',       label: 'ETF',       icon: '📈', Screen: ETF              },
  { id: 'reentry',   label: 'Re-Entry',  icon: '🎯', Screen: ReEntryAnalyzer  },
  { id: 'settings',  label: 'Settings',  icon: '⚙',  Screen: Settings         },
];

const STORAGE_KEY = 'isa_active_tab';

function getInitialTab() {
  try {
    const saved = localStorage.getItem(STORAGE_KEY);
    if (saved && TABS.find(t => t.id === saved)) return saved;
  } catch (_) {}
  return 'dashboard';
}

/* ── App shell ── */
function App() {

  const [activeTab, setActiveTab] = useState(getInitialTab);
  const notifProps = useNotifications();

  function handleTabChange(id) {
    setActiveTab(id);
    try { localStorage.setItem(STORAGE_KEY, id); } catch (_) {}
  }

  const current     = TABS.find(t => t.id === activeTab);
  const Screen      = current?.Screen ?? Dashboard;
  const screenProps = current?.id === 'settings' ? { notifProps } : {};

  return (
    <div className="app-shell">
      <header className="app-header">
        <span className="header-icon">💼</span>
        <h1>Investment Strategy App</h1>
      </header>

      <main className="app-content">
        <Screen {...screenProps} />
      </main>

      <nav className="bottom-nav" role="navigation" aria-label="Main navigation">
        {TABS.map(tab => (
          <button
            key={tab.id}
            className={`nav-tab${activeTab === tab.id ? ' active' : ''}`}
            onClick={() => handleTabChange(tab.id)}
            aria-label={tab.label}
            aria-current={activeTab === tab.id ? 'page' : undefined}
          >
            <span className="nav-icon" aria-hidden="true">{tab.icon}</span>
            <span className="nav-label">{tab.label}</span>
          </button>
        ))}
      </nav>
    </div>
  );
}

export default App;
